// extracted by mini-css-extract-plugin
export var stepActive = "_1k-3";
export var stepCompleted = "_1k-4";
export var stepConnectorLine = "_1k-b";
export var stepIndicatorCircle = "_1k-6";
export var stepIndicatorCircleCompleted = "_1k-7";
export var stepIndicatorCircleDefault = "_1k-8";
export var stepIndicatorTextCompleted = "_1k-9";
export var stepIndicatorTextDefault = "_1k-a";
export var stepPending = "_1k-5";
export var wizardContainer = "_1k-1";
export var wizardContent = "_1k-2";
export var wizardModal = "_1k-0";